module.exports = __webpack_public_path__ + "img/ヘリテージファウンド.1b47579d.png";